document.addEventListener('DOMContentLoaded', async ()=>{

  const weightLabel =
    document.getElementById('asia24-package-weight');

  const fill =
    document.getElementById('asia24-package-fill');

  if(!weightLabel || !fill) return;

  try{

    const cart =
      await fetch('/cart.js').then(r=>r.json());

    let totalWeight = 0;

    cart.items.forEach(item=>{

      totalWeight +=
        item.grams * item.quantity;

    });

    weightLabel.textContent =
      `${totalWeight}g / 1000g`;

    const percent =
      Math.min(
        (totalWeight / 1000) * 100,
        100
      );

    fill.style.width =
      percent + '%';

  }catch(error){

    console.log(error);

  }

});